import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Cookies from 'universal-cookie';
import axios from 'axios';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from 'firebase';
const config = {
  apiKey: 'AIzaSyB0XIn1TilBdvJcpfaBPAilXK1HLznLMaQ',
  authDomain: 'distributed-eye-251310.firebaseapp.com',
};
if (!firebase.apps.length) {
firebase.initializeApp(config);
}

     const uiConfig = {
        signInFlow: 'popup',
        signInOptions: [
          firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        ],
        callbacks: {
   // Avoid redirects after sign-in.
        signInSuccessWithAuthResult: function(authResult, redirectUrl) {
          var formdata = new FormData();
          formdata.set('phone', authResult['user']['phoneNumber']);
          axios({
            method: 'post',
            url: localStorage.getItem('api_url')+'webphonelogin',
            data : formdata,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
          }).then(res => {
              var hosturl = window.location.href;
              const cookies = new Cookies();
              if(res.data.peoples) {
                
                var loginstatus = new FormData();
                loginstatus.set('user_id', res.data.peoples.user_id);
                loginstatus.set('status', '1');
                //loginstatus.set('language', this.state.langKey);    
                axios({
                    method: 'post',
                    url: localStorage.getItem('api_url')+'webonlinestatus',
                    data: loginstatus,
                    config: { headers: {'Content-Type': 'multipart/form-data' }}
                    })
                    
                let d = new Date();
                d.setTime(d.getTime() + (12*60*60*1000));   
                cookies.set('onboarded', 'true', {path: "/", expires: d});       
                localStorage.setItem('session_token',JSON.stringify(res.data.peoples.token));
                localStorage.setItem('session_userid',JSON.stringify(res.data.peoples.user_id));
                sessionStorage.setItem('loggedin', 'true');
                hosturl = hosturl.replace('phonelogin','');
                window.location.href = hosturl+"app/PeopleNear";
              } else {
                if(res.data.status === "notreg") {
                  cookies.set('signuptab','yes');
                  cookies.set('signupmobileno',authResult['user']['phoneNumber']); 
                  hosturl = hosturl.replace('phonelogin','');
                  //this.setState: ({ phone : authResult['user']['phoneNumber']});
                  window.location.href = hosturl+"login";
                  //window.location.href = hosturl+"login";
                  
                } 
              }
              
          })
        } 
        }
      };
   
   
   
class Phonelogin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            api_url:localStorage.getItem('api_url'),
        };
      }

     
    
 
    componentDidMount(){
        const cookies = new Cookies();
       if(cookies.get('onboarded') === 'true'){
         //alert("s");
         this.props.history.push("/app")
           
         
         }else{
            //  this.props.history.push("/login");
            //  window.location.reload();
   
         }
    }
  
  
    render() {
        return (

            <div className="welcomePage">
        

                <div className="welcomePageCenterContent">

                    <div className="welcomeLogo"></div>

                   

<div className="w-100">
 <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
</div>

                    <div class="white-color esmh-14 text-center amt10"><b>By using our services you are agreeing to <span> <NavLink to="/helpmain" className="white-color"> Terms and Conditions </NavLink></span></b></div>


                </div>




            </div>

        );
    }

}




export default Phonelogin;
